import { CUSTOM_SIZES } from "modules/category/constants/customSizesConstants";
import qs from "query-string";
import { filterObjectKeys } from "util/lodash/filterObjectKeys";
import { validateVehicle } from "util/vehicle/validate-vehicle";
import { WHITELIST_PARAMS, validQueryParams } from "../../modules/category/constants/constants";
import { pick } from "../lodash/pick";
import PASentry from "../pa-sentry";
import { PAGE_TYPES, TIER_MAKE_MODEL_PAGES } from "../product/product-constants";
import { getHrefAndPath } from "../url/getHrefAndPath";

export function __getHrefAndPath({
  query, item, pageType, tiersWithUrls,
  appliedFilters, category, previousTierUrl,
  previousTierPageType, selectedVehicle, removeFilterableAttributes,
}) {
  const allQuery = process.browser ? qs.parse(location.search) : query;
  const customSizesObject = filterObjectKeys(appliedFilters, CUSTOM_SIZES);

  const queryParams = {
    // to handle /doors?t2=moulding&t3=door%20guard
    tier0: query.t0,
    tier1: query.t1,
    tier2: query.t2,
    tier3: query.t3,
    ...(!removeFilterableAttributes && { ...allQuery }),
    // remvoe t0-3 to remove unwanted QP, those might come from old pages.
    t0: undefined,
    t1: undefined,
    t2: undefined,
    t3: undefined,
    pathname: undefined,
    // always page number will be 1.
    pageNumber: undefined,
  };
  // when we navigate from t3 to another t3, and both doesn't have canonical URL.
  if (query.tier3) {
    delete queryParams.tier3;
  }
  let newPathName;

  if (item.url) {
    newPathName = item.url;

    // user clicks on tier0
    if (category.tier0 && !category.tier1) {
      newPathName = newPathName || previousTierUrl || query.pathname;
    }
    // selected vehicle is required in query params
    // If we are going to MAKE_MODEL_PAGES pages, make & model will be removed from query. See below comment line 75
    // Bug:
    // 1. GOTO Jeep Truck Wrangler Radiator & Parts | PartsAvatar
    // 2. click Radiator Cap from category tree
    // 3. make and model added in URL
    if (validateVehicle(selectedVehicle)) {
      queryParams.make = selectedVehicle.make;
      queryParams.model = selectedVehicle.model;
      queryParams.year = selectedVehicle.year;
    }
    delete queryParams.tier0;
    delete queryParams.tier1;
    delete queryParams.tier2;
    delete queryParams.tier3;
  } else {
    queryParams.tier1 = category.tier1;
    queryParams.tier2 = category.tier2;
    queryParams.tier3 = category.tier3;
    if (validateVehicle(selectedVehicle)) {
      queryParams.make = selectedVehicle.make;
      queryParams.model = selectedVehicle.model;
      queryParams.year = selectedVehicle.year;
    }
    try {
      newPathName = previousTierUrl || query.pathname;
    } catch (err) {
      PASentry.logException(err, {}, {
        tiersWithUrls, category, pathname: query.pathname, item,
      });
    }
  }

  // remove engine from QP
  queryParams.engine = undefined;
  queryParams.scroll = undefined;

  // Remove make & model if it is a make model page
  if (TIER_MAKE_MODEL_PAGES.includes(item.pageType)) {
    delete queryParams.make;
    delete queryParams.model;
  } else if (!item.url && previousTierPageType && TIER_MAKE_MODEL_PAGES.includes(previousTierPageType)) {
    delete queryParams.make;
    delete queryParams.model;
  }

  if (pageType === PAGE_TYPES.MANUFACTURER_TIER1_PAGE
    || pageType === PAGE_TYPES.MANUFACTURER_TIER2_PAGE
  ) {
    queryParams.manufacturers = appliedFilters.manufacturer;
  }
  const {
    href,
    asPath,
  } = getHrefAndPath({
    queryString: qs.stringify({ ...pick(queryParams, process.browser ? validQueryParams : WHITELIST_PARAMS), ...customSizesObject }),
    href: newPathName,
    asPath: newPathName,
  });
  return { href, asPath };
}
